import React from 'react';
import './GasData.css';

function GasData({ freight_totals = [] }) {
  const hasData = freight_totals.length > 0;

  const {
    freight_both_total = 0,
    freight_diesel_total = 0, 
    freight_gas_total = 0,  
  } = freight_totals[0] || {}; 

  return (
    hasData ? (
      <div className="cards">
        <h2 className="card-title">Total Revenue from Diesel and Gas</h2>
        <p className="card-value">\u20b9 {freight_both_total.toLocaleString()}</p>

        <h2 className="card-title">Total Revenue from Diesel</h2>
        <p className="card-value">\u20b9 {freight_diesel_total.toLocaleString()}</p>

        <h2 className="card-title">Total Revenue from Gas</h2>
        <p className="card-value">\u20b9 {freight_gas_total.toLocaleString()}</p>
      </div>
    ) : (
      <div className="no-data-message">No data available</div>
    )
  );
}

export default GasData;
